import React, { ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface TooltipProps {
  content: string;
  children: ReactNode;
  className?: string;
  side?: 'top' | 'bottom' | 'left' | 'right';
}

export const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  className,
  side = 'top',
}) => {
  const sideClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  return (
    <div className={cn("relative group w-full", className)}>
      {children}
      <div
        className={cn(
          "absolute z-[100] px-3 py-2 text-sm text-white bg-gray-900 rounded shadow-xl",
          "opacity-0 invisible group-hover:opacity-100 group-hover:visible",
          "transition-opacity duration-200 pointer-events-none",
          "max-w-md whitespace-normal break-words",
          sideClasses[side]
        )}
      >
        {content}
      </div>
    </div>
  );
};
